<template>
  <!--min-h-[calc(100vh-17.6vh)] h-[calc(100%-17.6vh)] mt-11 -->
  <div id="intro" class="w-full relative pt-24 pb-32">
    <div id="starGroupBackground" class="pb-14 absolute left-0 bottom-0" style="width: 7.15vw">
      <img src="@/assets/images/shared/starGroupBackgroundBrown.svg" id="stargroupbackgroundBrown" v-show="homeStore.selected.id == 'corporate'" />
      <img src="@/assets/images/shared/starGroupBackgroundPurple.svg" id="stargroupbackgroundPurple" v-show="homeStore.selected.id == 'insurer'" />
      <img src="@/assets/images/shared/starGroupBackgroundGreen.svg" id="stargroupbackgroundGreen" v-show="homeStore.selected.id == 'patients'" />
    </div>

    <div id="introContent" class="flex justify-center">
      <div id="introDescription" style="min-width: 30vw">
        <div class="text-sm italic font-jost">{{ t("home.companyName") }}</div>
        <div class="text-3xl font-bold" v-html="t('home.companyDesc')" />

        <div id="introSelectionList">
          <template v-for="(item, index) in homeStore.selectionList" :key="'navItem' + index">
            <div
              class="cursor-pointer text-6xl w-fit pt-8 transition duration-700 ease-in-out"
              :style="[homeStore.selected == item ? 'color: var(--' + homeStore.selected.id + '-color); font-weight:bold;' : 'color: #DAE1E7']"
              @click="
                homeStore.selected = item;
                resetIntroTimer();
              "
            >
              {{ t(item.label) }}
            </div>
            <template v-if="homeStore.selected == item">
              <div class="text-lg text-description py-4 font-jost transition duration-700 ease-in-out">
                <span v-html="t(item.description)"></span>
              </div>
              <!-- <button-util buttonType="submit" :bgColor="'var(--' + homeStore.selected.id + '-color)'" label="common.learnMore" @click="goToLocation(homeStore.selected.id)" /> -->
            </template>
          </template>
        </div>
      </div>

      <div id="egg" class="relative mt-8" style="width: 33.6vw">
        <transition-group name="slide-fade" tag="section">
          <div v-if="homeStore.selected.id == 'corporate'" key="corporateEgg">
            <div id="eggImage" class="absolute right-0" style="width: 33.75rem; width: 27vw">
              <img :src="commonStore.getImgUrl('home', 'introCorporate', 'svg')" style="width: inherit" />
            </div>
            <div id="eggLine" class="absolute -z-10 min-w-max overflow-hidden" style="top: -5.5vw; right: -5vw; padding: inherit; width: 34vw">
              <img :src="commonStore.getImgUrl('home', 'eggLineBrown', 'svg')" class="animate-spin-slow" style="width: inherit" />
            </div>
          </div>

          <div v-else-if="homeStore.selected.id == 'insurer'" key="insurerEgg">
            <div id="eggImage" class="absolute right-0" style="width: 33.75rem; width: 27vw">
              <img :src="commonStore.getImgUrl('home', 'introInsurer', 'svg')" style="width: inherit" />
            </div>
            <div id="eggLine" class="absolute -z-10 min-w-max overflow-hidden" style="top: -5.5vw; right: -5vw; padding: inherit; width: 34vw">
              <img :src="commonStore.getImgUrl('home', 'eggLinePurple', 'svg')" class="animate-spin-slow" style="width: inherit" />
            </div>
          </div>

          <div v-else-if="homeStore.selected.id == 'patients'" key="patientsEgg">
            <div id="eggImage" class="absolute right-0" style="width: 33.75rem; height: 27.5rem; width: 27vw">
              <img :src="commonStore.getImgUrl('home', 'introPatients', 'svg')" style="width: inherit" />
              <!--<div class="bg-no-repeat relative" style="background-image: url('/src/assets/images/introPatients.svg'); width: inherit; height: inherit"></div>-->
            </div>
            <div id="eggLine" class="absolute -z-10 min-w-max overflow-hidden" style="top: -5.5vw; right: -5vw; padding: inherit; width: 34vw">
              <img :src="commonStore.getImgUrl('home', 'eggLineGreen', 'svg')" class="animate-spin-slow" style="width: inherit" />
            </div>
          </div>
        </transition-group>
      </div>
    </div>

    <div id="introGuideMouse" class="absolute left-1/2 bottom-0 pb-10 cursor-pointer flex flex-col items-center" style="transform: translate(-50%, 0); width: 1vw" @click="goTo('ourCoreValues')">
      <!-- Mouse -->
      <svg width="18" height="26" viewBox="0 0 18 26" fill="none" xmlns="http://www.w3.org/2000/svg" style="width: inherit">
        <path
          d="M9.84931 0H7.8549C3.73339 0 0.504883 3.35881 0.504883 7.64668V18.3525C0.504883 22.6408 3.73339 26 7.8549 26H9.84931C14.0652 26 17.4952 22.5694 17.4952 18.3525V7.64668C17.4952 3.43031 14.0652 0 9.84931 0ZM8.92288 4.0072H9.07718C9.31835 4.0072 9.51465 4.20344 9.51465 4.44467V7.559C9.51465 7.80023 9.31835 7.99647 9.07718 7.99647H8.92288C8.68171 7.99647 8.48541 7.80023 8.48541 7.559V4.44467C8.48541 4.20344 8.68171 4.0072 8.92288 4.0072ZM16.4953 18.3525C16.4953 22.018 13.5139 25.0001 9.84931 25.0001H7.8549C4.29404 25.0001 1.50481 22.0801 1.50481 18.3525V7.64668C1.50481 3.91958 4.2941 0.999925 7.8549 0.999925H8.49391V3.07271C7.91021 3.25563 7.48549 3.80147 7.48549 4.44473V7.55906C7.48549 8.20226 7.91021 8.74816 8.49391 8.93102V11.5037C8.49391 11.7798 8.71777 12.0037 8.99388 12.0037C9.26998 12.0037 9.49384 11.7798 9.49384 11.5037V8.93465C10.0839 8.7556 10.5146 8.20676 10.5146 7.55906V4.44467C10.5146 3.79697 10.0839 3.24813 9.49384 3.06902V0.999925H9.84931C13.5139 0.999925 16.4953 3.98164 16.4953 7.64668V18.3525Z"
          fill="#AAAAAA"
        />
      </svg>
      <!-- Down Icon -->
      <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg" style="width: inherit">
        <path d="M1 1L7 7L13 1" stroke="#878787" />
      </svg>

      <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg" style="width: inherit">
        <path d="M1 1L7 7L13 1" stroke="#878787" />
      </svg>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useHomeStore } from "@/stores/home";
import { useHeaderStore } from "@/stores/header";
import { computed, onMounted, ref, toRefs } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import { useCommonStore } from "@/stores/common";

const headerStore = useHeaderStore();
const homeStore = useHomeStore();
const router = useRouter();
const commonStore = useCommonStore();
const { t, locale } = useI18n();

var activeIntro = null;

onMounted(async () => {
  if (homeStore.selected.id == null) {
    homeStore.selected = homeStore.selectionList[0];
  }
  //set max height for the intro
  /*var headerHeight = document.getElementById("header").offsetHeight;
  console.log("header height: " + headerHeight);
  document.getElementById("intro").style.minHeight = "calc( 100vh - " + (headerHeight + 5) + "px )";
  document.getElementById("intro").style.height = "calc( 100% - " + (headerHeight + 5) + "px )";*/

  changeActiveIntro();
});

const changeActiveIntro = () => {
  activeIntro = setInterval(() => {
    var currentSelectedIndex = homeStore.selectionList.findIndex((element) => element == homeStore.selected);
    if (currentSelectedIndex == homeStore.selectionList.length - 1) homeStore.selected = homeStore.selectionList[0];
    else homeStore.selected = homeStore.selectionList[currentSelectedIndex + 1];
    console.log("change active intro: " + homeStore.selected.id);
    //if (count == this.ratings.length) clearInterval(x);
  }, 5000);
};

const resetIntroTimer = () => {
  clearInterval(activeIntro);
  changeActiveIntro();
};

//not on home page, stop intro timer
router.beforeEach(async (to, from) => {
  console.log("stop intro timer: " + activeIntro);
  if (to.name != "home") {
    clearInterval(activeIntro);
    homeStore.selected = homeStore.selectionList[0];
  }
});

const goTo = (refName) => {
  var element = document.getElementById(refName).offsetTop;
  var headerHeight = document.getElementById("menu").offsetHeight;
  var top = element - headerHeight;

  window.scrollTo(0, top);
};

const routeTo = (position) => {
  router.push({ name: position, params: { uid: "lczmx" } });
};

const goToLocation = (id) => {
  switch (id) {
    case 'corporate':
      routeTo('aboutcorporate');
      break;
    case 'insurer':
      routeTo('aboutinsurer');
      break;
    case 'patients':
      routeTo('aboutpatients');
      break;
  }
  // routeTo(id);
};
</script>


<style scoped>
.slide-fade-enter-active {
  transition: all 1s ease;
}

.slide-fade-enter-active img {
  transition: all 1s ease;
}

.slide-fade-leave-active {
  transition: all 1s ease;
}

.slide-fade-leave-active img {
  transition: all 1s ease;
}

.slide-fade-enter,
.slide-fade-leave-to {
  opacity: 0;
}

.slide-fade-enter img,
.slide-fade-leave-to img {
  filter: blur(10px);
  transform: scale(1) rotate(3deg);
}
</style>